import React, { useState } from 'react';
import styles from '../../css/modal.module.scss';
import ActionButton from 'components/ActionButton';
import ImageUploadComponent from 'components/ImageUploadComponent';
import { isValidURL, showError } from 'utils';
import { populatePurchaseOrderItemsFromImage } from 'services';

const PopulateItemsWithImageModal = props => {
  const {
    onCancel,
    onSuccess,
    loading,
    supplierId,
    setLoading,
  } = props;

  const [url, setURL] = useState('');

  const populatePurchaseOrderItemsFromImageFn = async () => {
    setLoading(true);
    try {
      const response = await populatePurchaseOrderItemsFromImage({ supplierId, imageURL: url });
      onSuccess(response?.lineItems);
    } catch (e) {
      showError(e);
    } finally{
      setLoading(false);
    }
  };

  return (
    <div className={styles['main-container']}>
      <div className={styles['modal-container']}>
        <div className={styles['modal-header']}>
          <div>
            <div className={styles['label']}>Populate</div>
            <div className={styles['modal-title']}>Add Image</div>
          </div>
          <i className={'fa fa-times'} onClick={onCancel} />
        </div>
        <div className={styles['modal-body']}>
          <div className={styles['image-section']}>
            <div className={styles['image-container']}>
              <ImageUploadComponent
                src={isValidURL(url) ? url : ''}
                entityId={''}
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                toggleModal={() => { }}
                uploadAPI={(id, image) => setURL(image.url())}
              />
            </div>
          </div>
          <div className={styles['input-section']}>
            <div className={styles['input-group']}>
              <div className={styles['label']}>Image URL</div>
              <input
                className={'form-control mr-2'}
                disabled={loading}
                value={url}
                onChange={e => setURL(e.target.value)}
                placeholder='https://blog.puertoricoproduce.com/recetas'
              />
            </div>
          </div>
        </div>
        <div className={styles['modal-footer']}>
          <div className={styles['cancel-button']}>
            <ActionButton
              text={'Cancel'}
              active={!loading}
              isLoading={false}
              onClick={onCancel}
              customClass='mr-2'
            />
          </div>
          <div className={styles['submit-button']}>
            <ActionButton
              text={'Populate Items'}
              active={!loading && !!url && isValidURL(url)}
              isLoading={loading}
              onClick={populatePurchaseOrderItemsFromImageFn}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PopulateItemsWithImageModal;
